import { render } from "./downloadMobile.vue?vue&type=template&id=5cd3c430&scoped=true"
import script from "./downloadMobile.vue?vue&type=script&lang=js"
export * from "./downloadMobile.vue?vue&type=script&lang=js"

import "./downloadMobile.vue?vue&type=style&index=0&id=5cd3c430&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cd3c430"]])

export default __exports__